import { useEffect, useState } from 'react';
import { loadScript } from '../utils';
import { Google } from '../types/google';

type Libraries = 'drawing' | 'geometry' | 'localContext' | 'places' | 'visualization';

type GoogleMapsProps = {
    key: string;
    libraries?: Libraries[] | undefined;
    v?: string;
    language?: string;
    region?: string;
    callback?: (google: Google) => void;
}

type GoogleMaps = {
    isLoading: boolean;
    error: string | null;
    google: Google | null
}

const useGoogleMaps: (GoogleMapsProps: GoogleMapsProps) => GoogleMaps = ({ key, libraries, callback, ...rest}) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setErrors] = useState<string | null>(null);
    const [google, setGoogle] = useState<Google | null>(null);

    useEffect(() => {
        if (google) {
            return;
        }
        else if (window.google) {
            setGoogle(window.google);
            return;
        }
        
        setIsLoading(true);
        
        if (error) {
            setErrors(null);
        }
        
        const url = new URL('https://maps.googleapis.com/maps/api/js');
        url.searchParams.append('key', key);
        
        if (libraries) {
            url.searchParams.append('libraries', libraries.join(','));
        }
        
        Object.entries(rest).forEach(([key , value]) => {
            if (!value) {
                return;
            }

            url.searchParams.append(key, value);
        });
        
        loadScript({
            // src: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=geometry,places`,
            src: url.href,
            id: 'google-maps',
            onLoad: () => {
                setIsLoading(false);
                setGoogle(window.google);
                
                if (callback) {
                    callback(window.google);
                }
            },
            onError: (event) => {
                setIsLoading(false);
                setErrors(`Error google.maps script loading!`);

                console.error(event);
            }
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return {
        isLoading,
        error,
        google,
    } as const;
};

export default useGoogleMaps;